import { useTranslation } from 'react-i18next'
import { rgba } from 'polished'
import styled, { css } from 'styled-components'

import { colors } from 'bl-common/src/constants/colors'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { Section } from 'bl-common/src/units/Section/Section'
import { media, mediaMax } from 'bl-common/src/utils/media'
import { formatDateInUTC } from 'bl-utils/src/formatting/formatDate'

const Meta = styled.div`
  display: flex;

  ${mediaMax.md(css`
    flex-wrap: wrap;
  `)}
`

const Author = styled.div`
  ${media.md(css`
    display: flex;
    &::before {
      content: '';
      width: 2px;
      height: 100%;
      display: block;
      background: ${colors.lagoonBlue};
    }
  `)}
`

const DateContainer = styled.div`
  display: flex;
  align-items: center;

  ${mediaMax.md(css`
    width: 100%;
    margin-bottom: 6px;
  `)}

  &::before {
    content: '';
    width: 8px;
    height: 1px;
    background: ${rgba(colors.midGrey, 0.5)};
    margin-right: 12px;
    display: block;
  }
`

export const StoryMeta = ({
  storyAuthor,
  storyPublishDate,
  storyReadingTime,
}) => {
  const { t, i18n } = useTranslation()
  const date = formatDateInUTC(storyPublishDate, 'PP', i18n.language)
  const faded = rgba(colors.midGrey, 0.5)
  return (
    <Section as="aside" top={{ xs: 1 }} bottom={{ xs: 2.5, md: 5 }}>
      <Meta>
        <DateContainer>
          <Type size={{ xs: 12, md: 16 }} right={{ md: 1 }} color={faded}>
            {date}
          </Type>
        </DateContainer>
        <Author>
          <Type
            case="capitalize"
            weight="bold"
            size={{ xs: 12, md: 16 }}
            left={{ md: 1 }}
            right={{ xs: 1 }}
          >
            {storyAuthor.fields.name}
          </Type>
        </Author>
        <div>
          <Type color={faded} size={{ xs: 12, md: 16 }}>
            {t('readTime', { minutes: storyReadingTime })}
          </Type>
        </div>
      </Meta>
    </Section>
  )
}
